export default "__VITE_ASSET__b3921562__"